import React, { Component } from "react";
import { download, download_guide } from "../../resources/string/strings"
import { ReactComponent as IconDownload } from "../../resources/image/ic_download_folder.svg";

class Adapter extends Component {
  state = {
  };

  render() {
    const { files, title } = this.props;

    return (

      <div style={{ textAlign: "right" }} >

        <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right" , marginBottom: 10}}>
          <IconDownload
            className="p-0"
            width="25"
            height="25"
          />
          <span style={{ fontSize: 13, color: "dimgrey", marginRight: 6 }}>{title}</span>

        </div>

        {files.map((item) => (
         <div
          key={item.title}
           style={{ fontSize: 13, color: "black", marginBottom: 10 }}>

            <span> {item.title}:</span>
      
            <span style={{marginRight: 10}}>
               <a 
                   target="_parent " 
                   style={{ height: 16, width: 70, fontSize: 13, textDecoration: "none" }}
                   className="clear-link m-0 p-0 "
                   href={item.fileUrl}
                   rel="noopener noreferrer">{download}</a>

            </span>
            
            </div>
        ))}

        <div style={{fontSize: 11, color: "gray", marginTop: 20}}>{download_guide}</div>
      </div>
    );
  }
}

export default Adapter;
